import { render, staticRenderFns } from "./BaseCourseList.vue?vue&type=template&id=b6b58e44&"
import script from "./BaseCourseList.vue?vue&type=script&lang=js&"
export * from "./BaseCourseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports